import { useState, useEffect } from "react";
import axios from "axios";
import { API_URL } from "../constants";

function MotorReplacements({ motor, token , user }) {
  const [remplacements, setRemplacements] = useState([]);
  const [allMoteurs, setAllMoteurs] = useState([]);
  const [selectedReplaceId, setSelectedReplaceId] = useState("");
  const [showConfirm, setShowConfirm] = useState(false);
  const [toDeleteId, setToDeleteId] = useState(null);

  // Charger les remplacements actuels
  useEffect(() => {
    const fetchRemplacements = async () => {
      try {
        const res = await axios.get(
          `${API_URL}/moteur/${motor._id}/remplacement`,
          { headers: { Authorization: "Bearer " + token } }
        );

        const listRes = await axios.get(
          `${API_URL}/moteur/listmoteur?id=${user.userId}`,
          { headers: { Authorization: "Bearer " + token } }
        );

        const all = listRes.data.data;
        const mapped = res.data.remplacements || [];

        setRemplacements(mapped);
        setAllMoteurs(all);
      } catch (err) {
        console.error("Erreur récupération remplacements:", err);
      }
    };

    fetchRemplacements();
  }, [motor, token]);

  // Associer un moteur
  const addReplacement = async () => {
    if (!selectedReplaceId) return;
    try {
      await axios.post(
        `${API_URL}/moteur/${motor._id}/remplacements/${selectedReplaceId}`,
        {},
        { headers: { Authorization: "Bearer " + token } }
      );

      setRemplacements((prev) => [
        ...prev,
        allMoteurs.find((m) => m._id === selectedReplaceId),
      ]);
      setSelectedReplaceId("");
    } catch (err) {
      console.error("Erreur association remplacement:", err);
    }
  };

  // Supprimer un moteur
  const confirmDelete = (id) => {
    setToDeleteId(id);
    setShowConfirm(true);
  };

  const removeReplacement = async () => {
    try {
      await axios.delete(
        `${API_URL}/moteur/${motor._id}/remplacement/${toDeleteId}`,
        { headers: { Authorization: "Bearer " + token } }
      );
      setRemplacements((prev) => prev.filter((m) => m._id !== toDeleteId));
    } catch (err) {
      console.error("Erreur suppression remplacement:", err);
    } finally {
      setShowConfirm(false);
      setToDeleteId(null);
    }
  };

  return (
    <div className="border border-bleuSTB rounded-2xl p-6 mt-6 shadow-md bg-white">
      <h3 className="text-xl md:text-2xl font-bold text-marronSTB mb-6 text-center">
        Boitier de remplacement
      </h3>

      {remplacements.length > 0 ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {remplacements.map((r) => (
            <div
              key={r._id}
              className="flex flex-col sm:flex-row justify-between items-start sm:items-center bg-gray-50 p-4 rounded-xl shadow-sm hover:shadow-md transition-all"
            >
              <span className="text-base font-semibold text-gray-800 mb-2 sm:mb-0">
                {r.nom_moteur}
              </span>
              <button
                onClick={(event) => {event.stopPropagation();confirmDelete(r._id);}}
                className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded-lg text-sm transition-all w-full sm:w-auto mt-2 sm:mt-0 sm:ml-4 box-border max-w-full"
              >
                Supprimer
              </button>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-gray-500 text-base italic text-center">
          Aucun boitier de remplacement
        </p>
      )}
      <div className="mt-6 flex flex-col sm:flex-row gap-3 items-center">
        <select
          value={selectedReplaceId}
          onChange={(e) => setSelectedReplaceId(e.target.value)}
          onClick={(e) => e.stopPropagation()}
          className="w-full sm:flex-1 border border-gray-300 rounded-lg px-3 py-2 text-base focus:ring-2 focus:ring-bleuSTB focus:outline-none"
        >
          <option value="">-- Choisir un moteur --</option>
          {allMoteurs
            .filter(
              (m) =>
                m._id !== motor._id &&
                !remplacements.find((r) => r._id === m._id)
            )
            .map((m) => (
              <option key={m._id} value={m._id}>
                {m.nom_moteur}
              </option>
            ))}
        </select>
        <button
          onClick={(event) => {event.stopPropagation();addReplacement();}}
          className="w-full sm:w-auto bg-green-500 hover:bg-green-600 text-white px-3 py-2 text-base rounded-lg transition-all"
        >
          Associer
        </button>
      </div>
      {showConfirm && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl p-6 w-11/12 max-w-sm shadow-lg">
            <h4 className="text-lg font-bold text-gray-800 mb-4">
              Confirmer la suppression
            </h4>
            <p className="text-gray-600 text-base mb-6">
              Êtes-vous sûr de vouloir supprimer ce moteur de remplacement ?
            </p>
            <div className="flex justify-end gap-3">
              <button
                onClick={(event) => {event.stopPropagation();setShowConfirm(false);}}
                className="px-4 py-2 rounded-lg bg-gray-200 hover:bg-gray-300 text-lg text-gray-800 transition-all"
              >
                Annuler
              </button>
              <button
                onClick={(event) => {event.stopPropagation();removeReplacement();}}
                className="px-4 py-2 rounded-lg bg-red-500 hover:bg-red-600 text-lg text-white transition-all"
              >
                Supprimer
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default MotorReplacements;